//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQButton from "@/components/Generics/AQButton/AQButton";
import AQInput from "@/components/Generics/AQInput/AQInput";
import AQCheckbox from "@/components/Generics/AQCheckbox/AQCheckbox";
import AQChip from "@/components/Generics/AQChip/AQChip";
import AQCard from "@/components/Generics/AQCard/AQCard";

export default {
    name: "ConfigurationTemplate",
    components: {
        AQButton,
        AQInput,
        AQChip,
        AQCheckbox,
        AQCard
    },
    props: {
        template: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
        };
    },
    created() {
    },
    methods: {
        chipContent(value) {
            if (value.statusConfiguration === "SHOULD") {
                return this.$t("smartContract.useTemplateSC.notConfig");
            } if (value.statusConfiguration === "OPTIONAL") {
                return this.$t("smartContract.useTemplateSC.optionalValues");
            }
        },
        enableProceedToDetails(contracts) {
            return contracts.some(e => e.statusConfiguration === "SHOULD");
        },
        enableSave(contract) {
            let saveContract = false;
            if (contract.properties) {
                saveContract = contract.properties.some(elem => elem.isMandatory && !elem.value);
            }
            if (saveContract) {
                contract.statusConfiguration = "SHOULD";
            } else {
                const optional = contract.properties.every(elem => !(elem.isMandatory || elem.value));
                if (optional) {
                    saveContract = true;
                    contract.statusConfiguration = "OPTIONAL";
                }
            }
            return saveContract;
        },
        elementName(value) {
            return value.isMandatory ? `${value.name}*` : value.name;
        },
        saveContract(contract) {
            contract.statusConfiguration = "NO";
        },
        proceedToDetails(object) {
            this.$emit("proceedToDetails", object);
        }
    }
};
